import { Flex, Stack } from '@mantine/core';
import { useOutcomes } from '../../../api/strategy-client/strategy-client.hooks';
import { useTranslation } from 'react-i18next';
import { OverviewCard } from '../../../components/overview-card/overview-card';
import type { VerticalBarCardData } from '../../../components/overview-card/overview-card.type';
import { ProgressBarCard } from '../../../components/overview-card/progress-bar-card';
import { VerticalBarCard } from '../../../components/overview-card/vertical-bar-card';
import { round } from '../../../helpers/math-helpers/math-helpers';
import {
  graphLightRed,
  graphPictonBlue,
  graphPistachio,
  graphSunglow,
  skyBase,
  skyDark,
} from '../../../styles/design-tokens';
import { H3, Text } from '../../../ui-library/typography/typography';

export const OutcomesOverview = () => {
  const i18n = useTranslation();
  const { outcomes } = useOutcomes();

  // Calculate status data
  const onTrackOutcomes = outcomes.filter((o) => o.status?.by_tasks?.status === 'on_track').length;
  const atRiskOutcomes = outcomes.filter((o) => o.status?.by_tasks?.status === 'at_risk').length;
  const offTrackOutcomes = outcomes.filter((o) => o.status?.by_tasks?.status === 'off_track').length;

  const statusesData: VerticalBarCardData = [
    { category: 'Off Track', value: offTrackOutcomes, fill: graphLightRed },
    { category: 'At Risk', value: atRiskOutcomes, fill: graphSunglow },
    { category: 'On Track', value: onTrackOutcomes, fill: graphPistachio },
  ];

  // Calculate state data
  const noEndDateOutcomes = outcomes.filter((o) => !o.end_date).length;
  const noStartDateOutcomes = outcomes.filter((o) => !o.start_date).length;

  const statusesExtraData: VerticalBarCardData = [
    { category: 'No Start Date', value: noStartDateOutcomes, fill: skyBase },
    { category: 'No End Date', value: noEndDateOutcomes, fill: graphPictonBlue },
  ];

  // Calculate overall completion
  const overallCompletion =
    outcomes.length > 0
      ? round(outcomes.reduce((sum, outcome) => sum + (outcome.percent_progress || 0), 0) / outcomes.length, 2)
      : 0;

  return (
    <Flex direction="row" gap={24}>
      <VerticalBarCard
        title={`${i18n.t('common.outcomes')} by Statuses`}
        icon="insert_chart_outlined"
        data={statusesData}
      />
      <VerticalBarCard
        title={`${i18n.t('common.outcomes')} by State`}
        icon="insert_chart_outlined"
        data={statusesExtraData}
      />
      <ProgressBarCard
        title={`Overall ${i18n.t('common.outcomes')} Completion`}
        icon="check_circle"
        value={overallCompletion}
      />
      <OverviewCard
        title="Items"
        icon="show_chart"
        content={
          <Stack justify="center" align="center" gap={0} mt={10}>
            <H3>{outcomes.length}</H3>
            <Text size="tiny" lineHeight="tight" color={skyDark}>
              {`Total ${i18n.t('common.outcomes')}`}
            </Text>
          </Stack>
        }
      />
    </Flex>
  );
};
